<!--
 * @Description: 
 * @Author: wjx
 * @Github: 
 * @Date: 2019-05-23 09:52:22
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-08-24 14:19:09
 -->
<template>
  <div class="nav">
    <img
      class="hand"
      src="http://cdn.yxvzb.com/WEB/images/home%20(1).png"
      @click="goHome"
    />
    <span class="s1 hand" @click="goHome">首页</span>
    <span class="s2">{{ projectTypeName }}</span>
    <span class="s2">></span>
    <span class="s2" style="color: #666666;">{{ projectName }}</span>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from 'vuex';
export default {
  data() {
    return {
      // breadcrumbList: []
    };
  },
  methods: {
    goHome() {
      this.$router.push({ name: 'home' });
    }
  },
  computed: {
    ...mapState({
      projectTypeName: state => {
        if (state.homeProject.projectTypeName) {
          return state.homeProject.projectTypeName;
        } else {
          // 暂时解决v3项目刷新页面，store中的homeProject未初始化问题
          let projectTypeName = '';
          try {
            projectTypeName = JSON.parse(localStorage.getItem('homeProject'))
              .projectTypeName;
          } catch (error) {}
          return projectTypeName;
        }
      },
      projectName: state => {
        if (state.homeProject.projectName) {
          return state.homeProject.projectName;
        } else {
          // 暂时解决v3项目刷新页面，store中的homeProject未初始化问题
          let projectName = '';
          try {
            projectName = JSON.parse(localStorage.getItem('homeProject'))
              .projectName;
          } catch (error) {}
          return projectName;
        }
      }
    })
  },
  watch: {},
  components: {},
  created() {}
};
</script>
<style lang="scss" scoped>
.nav {
  display: flex;
  align-items: center;
  img {
    width: 27px;
    height: 27px;
    margin-right: 5px;
  }
  .s1 {
    font-size: 18px;
    color: #1989fa;
    margin-right: 20px;
  }
  .s2 {
    font-size: 16px;
    color: #343333;
  }
}
.app-breadcrumb.el-breadcrumb {
  display: inline-block;
  font-size: 14px;
  line-height: 50px;
  margin-left: 10px;
  .no-redirect {
    color: #97a8be;
    cursor: text;
  }
}
/*fade*/

// .breadcrumb-enter-active,
// .breadcrumb-leave-active {
//   transition: all 0.5s;
// }

// .breadcrumb-enter,
// .breadcrumb-leave-active {
//   opacity: 0;
//   transform: translateX(20px);
// }

// .breadcrumb-move {
//   transition: all 0.5s;
// }

// .breadcrumb-leave-active {
//   position: absolute;
// }
</style>
